import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingScreen } from "../../CommonComponents/LoadingScreen/index";
import OverviewInput from "../../CommonComponents/InitialInput/OverviewInput";
import OverviewButtons from "./Components/OverviewButtons";
import { useFetch } from "../../hooks/useFetch";
import { useMessage } from "../../hooks/UseMessage";
import ListModal from "../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../CommonComponents/CircleButton";
import MessageLog from "../../CommonComponents/Messages/MessageLog";
import { GetFullURL } from "../../CommonComponents/GlobalConfFiles/URLs";
import cardlogo from "../../Assets/cardLogo.svg";

function Index() {
  let navigate = useNavigate();



  const [inventoryDoc, setInventoryDoc] = useState();

  const [refDoc, setRefDoc] = useState();

  const [showInventoryDocList, setShowInventoryDocList] = useState(false);

  const [showRefDocList, setShowRefDocList] = useState(false);

  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();

  const [
    _getInventoryDocList,
    _inventoryDocList,
    ,
    ,
    ,
    ,
    ,
    _loadingInventoryDocList,
  ] = useFetch(GetFullURL("InventoryDocList"), { method: "POST" });

  const [_getInventoryDocExists, , , , , , , _loadingInventoryDocExist] =
    useFetch(GetFullURL("InventoryDocExists"), { method: "POST" });

  const [_getOrderList, _orderList, , , , , , _loadingOrderList] = useFetch(
    GetFullURL("OrderList"),
    { method: "POST" }
  );

  const [_getOrderExists, , , , , , , _loadingOrderExist] = useFetch(
    GetFullURL("OrderExists"),
    { method: "POST" }
  );

  const operationLoading =
    _loadingInventoryDocList ||
    _loadingInventoryDocExist ||
    _loadingOrderList ||
    _loadingOrderExist;

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        break;
      case "error":
        _setErorMessages([]);
        break;
      case "warning":
      default:
        break;
    }
  }

  return (
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                    <img src={cardlogo} alt="" />
                  </span>
                  Inventory Doc Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setInventoryDoc}
                    document={inventoryDoc}
                    placeholder="Inventory Doc id here..."
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`Inventory Documents`}
                    clickHandler={() => {
                      _getInventoryDocList({}, () => {
                        setShowInventoryDocList(true);
                      });
                    }}
                  />
                  <OverviewButtons
                    inventoryDoc={inventoryDoc}
                    refDoc={refDoc}
                    navigate={navigate}
                    _getInventoryDocExists={_getInventoryDocExists}
                    _getOrderExists={_getOrderExists}
                    _createErrorMessage={_createErrorMessage}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-12 mt-4">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                    <svg
                      width="51"
                      height="50"
                      viewBox="0 0 51 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M49.375 24.0111C48.9641 18.8608 46.9233 13.9749 43.5477 10.063C40.1725 6.15081 35.6382 3.4163 30.6036 2.25572C29.1804 0.814196 27.2391 0.0022018 25.2133 4.63687e-06C23.1874 -0.00223427 21.2451 0.806401 19.8185 2.24493C14.7834 3.40885 10.2493 6.14594 6.87432 10.0593C3.49872 13.973 1.45717 18.8595 1.04516 24.0112L0.443251 25.0561C0.0499403 25.7424 -0.0877547 26.5454 0.0547933 27.323C0.197714 28.1011 0.611171 28.803 1.22282 29.3045C5.77649 56.9075 44.654 56.8894 49.1983 29.3049C49.8114 28.8045 50.2264 28.1022 50.3693 27.3238C50.5118 26.5454 50.373 25.7416 49.9775 25.0561L49.375 24.0111ZM22.4597 6.05653L24.374 7.97904L27.9601 4.38477H27.9597C28.2892 4.06796 28.8116 4.07319 29.1348 4.39634C29.4583 4.71987 29.4636 5.2423 29.1468 5.57182L24.9674 9.7512C24.6371 10.0732 24.1106 10.0732 23.7803 9.7512L21.2727 7.24357C20.9574 6.9137 20.963 6.39239 21.2858 6.06962C21.6085 5.74684 22.1298 5.74124 22.4597 6.05656L22.4597 6.05653ZM18.3617 4.38181C17.3057 6.70918 17.5042 9.41388 18.8886 11.5621C20.273 13.7108 22.6538 15.0086 25.2096 15.0086C27.7654 15.0086 30.1465 13.7108 31.5309 11.5621C32.9153 9.41388 33.1138 6.70918 32.0578 4.38181C35.6035 5.52185 38.8135 7.51859 41.4032 10.1956C43.9925 12.8726 45.8819 16.1471 46.9035 19.7287L43.975 14.6578C43.5313 13.8906 42.8003 13.3312 41.9439 13.1029C39.5471 12.4618 36.3129 14.9023 37.0958 17.5667C33.0276 20.7244 28.583 13.6758 20.8168 19.9948C18.5905 18.5033 15.9784 17.6917 13.2987 17.6589C14.1469 14.9759 10.9937 12.4753 8.47569 13.103C7.61929 13.3314 6.88867 13.8908 6.44456 14.6579L3.51641 19.7288C4.53771 16.1472 6.42707 12.8727 9.01676 10.1957C11.6064 7.51869 14.8164 5.52185 18.3621 4.38191L18.3617 4.38181ZM1.88877 25.892C2.09625 25.5304 7.48207 16.1997 7.89027 15.4937L7.89064 15.4941C8.11491 15.1135 8.47986 14.8358 8.9064 14.7216C9.3333 14.6078 9.78818 14.666 10.1725 14.884L10.9166 15.3187L10.9162 15.3183C11.3002 15.54 11.5801 15.9049 11.6947 16.3329C11.8092 16.761 11.7488 17.217 11.5267 17.6006L11.2424 18.1021L5.53339 27.9903C5.31211 28.3762 4.94455 28.6568 4.51353 28.7676C3.77915 29.0172 3.01831 28.4784 2.41562 28.1239C2.0615 27.8877 1.81036 27.5261 1.71259 27.1119C1.61482 26.6977 1.67789 26.2618 1.88872 25.892L1.88877 25.892ZM25.2092 48.4435V48.4439C20.0025 48.4379 14.9571 46.6337 10.9277 43.336C6.89792 40.0388 4.13102 35.4504 3.09511 30.3479C3.33804 30.4244 3.59029 30.4688 3.84479 30.48C4.29034 31.8723 5.15573 33.0929 6.32223 33.9743C6.17409 34.6825 6.33865 35.4199 6.77338 35.9984C7.20849 36.5764 7.8712 36.9391 8.59254 36.9936C9.31386 37.0481 10.0236 36.7891 10.5405 36.2827L13.2989 33.5243C13.9209 32.8888 14.1594 31.9708 13.9261 31.1126C13.6929 30.2544 13.0223 29.5838 12.1641 29.3506C11.3058 29.1173 10.3882 29.3562 9.75239 29.9782L7.18697 32.5436C6.4246 31.9212 5.8466 31.1025 5.51483 30.1756C6.12905 29.8853 6.63987 29.4143 6.97871 28.8259L12.4452 19.3618C14.9281 19.2167 17.3962 19.8357 19.5169 21.1354C18.9903 21.6287 18.4552 22.1888 17.8951 22.8158C17.7275 23.002 17.6536 23.2542 17.6947 23.5013C18.1626 26.2332 20.7714 28.7434 24.7497 26.619C28.8118 24.5879 30.8179 26.7112 34.9808 31.7097C35.5648 32.4623 35.6159 32.5642 36.8533 32.7847C36.9522 33.2538 36.844 33.7426 36.5567 34.1266C36.2693 34.5102 35.8305 34.7517 35.3525 34.789C34.8745 34.8259 34.4036 34.6554 34.0603 34.321C34.0611 34.3169 30.8762 31.1391 30.8754 31.1354C30.547 30.8193 30.0261 30.8238 29.704 31.1458C29.3816 31.4682 29.3764 31.9891 29.6925 32.3172L32.871 35.4957V35.4961C33.1852 35.8084 33.3624 36.2331 33.3635 36.6761C33.3647 37.1194 33.1897 37.5448 32.8773 37.859C32.5646 38.1728 32.14 38.3501 31.6971 38.3508C31.2538 38.3519 30.8284 38.1769 30.5145 37.8642L27.4721 34.8218C27.143 34.5061 26.6217 34.5117 26.2997 34.8345C25.9777 35.1576 25.9736 35.6789 26.2904 36.0069C26.3001 36.0151 29.3287 39.0485 29.3391 39.0538C29.7484 39.4807 29.9022 40.0919 29.7432 40.6614C29.5842 41.2312 29.1364 41.6744 28.5655 41.8279C27.9942 41.9812 27.3849 41.8219 26.9621 41.4084L25.8251 40.2714C25.8113 40.2573 25.8005 40.2412 25.7863 40.2274C25.3385 39.811 24.7216 38.8915 24.0141 39.3833C23.3387 39.8632 23.6664 40.5991 24.2003 41.0107L24.5992 41.4144V41.4141C25.0112 41.8372 25.1683 42.4462 25.0131 43.0157C24.8578 43.5851 24.413 44.0299 23.8436 44.1855C23.2742 44.3408 22.6648 44.1833 22.242 43.7713C22.1244 43.6605 20.8967 42.4216 20.8229 42.3522L23.3137 39.8614V39.8611C23.9473 39.2278 24.1947 38.3042 23.9626 37.4389C23.7309 36.5736 23.0547 35.8978 22.1894 35.666C21.3241 35.4339 20.4009 35.6813 19.7673 36.3149L15.039 41.0432C14.417 41.6791 14.1781 42.5967 14.4114 43.4553C14.6446 44.3136 15.3152 44.9842 16.1734 45.2174C17.032 45.4506 17.9497 45.2118 18.5855 44.5897L19.6359 43.5393C19.7106 43.5967 20.9405 44.8561 21.0554 44.9587V44.9584C21.6356 45.5203 22.3987 45.8554 23.2052 45.9032C24.0119 45.9506 24.8086 45.7073 25.4512 45.2173C26.0938 44.7277 26.5394 44.0236 26.7072 43.2332C27.7763 43.7358 29.0313 43.6377 30.0089 42.9746C30.9866 42.3111 31.5419 41.1815 31.4702 40.0024C32.4277 40.0658 33.3659 39.7128 34.0446 39.0348C34.723 38.3564 35.0764 37.4183 35.0138 36.4608C35.9784 36.5283 36.924 36.1723 37.6054 35.4865C38.2864 34.8002 38.6353 33.8521 38.561 32.8882C40.8944 32.7498 43.0942 31.7523 44.7357 30.0881C45.5276 30.5205 46.4609 30.6142 47.3232 30.3482C46.2873 35.4507 43.5203 40.0395 39.491 43.3362C35.4612 46.6339 30.4165 48.438 25.2095 48.4441L25.2092 48.4435ZM48.0119 28.115C47.9862 28.137 47.2298 28.5698 47.1761 28.5997V28.6001C46.7361 28.8415 46.2133 28.8807 45.742 28.7075C45.2711 28.5348 44.8979 28.1661 44.7188 27.6974L38.8927 17.6C38.6707 17.2164 38.6106 16.7604 38.7248 16.3324C38.8393 15.9044 39.1192 15.5394 39.5028 15.3178L40.2469 14.883V14.8834C40.6309 14.6644 41.0857 14.6058 41.513 14.72C41.9403 14.8341 42.3052 15.1122 42.5288 15.4935L47.8034 24.6296C47.8422 24.68 48.4799 25.8028 48.5307 25.8916H48.5303C48.7408 26.2592 48.8042 26.6928 48.7083 27.1051C48.612 27.5178 48.3635 27.8787 48.0124 28.1153L48.0119 28.115Z"
                        fill="#43A5CA"
                      />
                      <path
                        d="M45.2698 25.8748C45.2765 26.3316 45.6489 26.6984 46.1057 26.6984C46.5628 26.6984 46.9348 26.3316 46.9415 25.8748C46.9348 25.4177 46.5628 25.0513 46.1057 25.0513C45.6489 25.0513 45.2765 25.4177 45.2698 25.8748Z"
                        fill="#EC9534"
                      />
                      <path
                        d="M4.31184 25.0389C3.8551 25.0457 3.48828 25.4177 3.48828 25.8748C3.48828 26.3316 3.85509 26.704 4.31184 26.7107C4.76897 26.7036 5.13541 26.3316 5.13541 25.8748C5.13541 25.4177 4.76859 25.0457 4.31184 25.0389Z"
                        fill="#EC9534"
                      />
                      <path
                        d="M19.0734 35.892C19.6951 35.2561 19.9335 34.3389 19.7003 33.4806C19.4671 32.6224 18.7965 31.9522 17.9383 31.7186C17.0804 31.4854 16.1628 31.7238 15.5269 32.3459L10.7986 37.0742C10.1766 37.71 9.93814 38.6277 10.1714 39.4859C10.405 40.3438 11.0752 41.0144 11.9334 41.2475C12.7916 41.4807 13.7093 41.2423 14.3447 40.6203L19.0734 35.892Z"
                        fill="#EC9534"
                      />
                    </svg>
                  </span>
                  Reference Document
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setRefDoc}
                    document={refDoc}
                    placeholder="Ref DOc id here..."
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`Reference orders`}
                    clickHandler={() => {
                      _getOrderList({}, () => {
                        setShowRefDocList(true);
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="row">
          <div className="col-12">
            <ListModal
              setId={setInventoryDoc}
              dataList={_inventoryDocList}
              showListModal={showInventoryDocList}
              setShowModal={setShowInventoryDocList}
              title="List Of Inventory Documents"
              columns={[
                { field: "id", headerName: "Shipping Doc ID", width: 250 },
                { field: "locationId", headerName: "Location", width: 350 },
                { field: "boLnumber", headerName: "BOL number", width: 250 },
                { field: "bolDate", headerName: "BOL Date", width: 200 },
                { field: "soldtoId", headerName: "Sold TO", width: 250 },
                { field: "shiptoId", headerName: "Ship TO", width: 250 },
                { field: "carrierId", headerName: "Carrier", width: 350 },
                { field: "createdBy", headerName: "Created By", width: 200 },
                { field: "createdOn", headerName: "Created On", width: 200 },
              ]}
            />
          </div>
          <div className="col-12">
            <ListModal
              setId={setRefDoc}
              dataList={_orderList}
              showListModal={showRefDocList}
              setShowModal={setShowRefDocList}
              columns={[
                { field: "id", headerName: "Shipping Doc ID", width: 250 },
                { field: "orderDate", headerName: "Date", width: 250 },
                { field: "locationId", headerName: "Location", width: 350 },
                { field: "soldtoId", headerName: "Sold TO", width: 200 },
                { field: "shiptoId", headerName: "Ship TO", width: 250 },
                { field: "carrierId", headerName: "Carrier", width: 250 },
                { field: "createdBy", headerName: "Created By", width: 350 },
                { field: "createdOn", headerName: "Created On", width: 200 },
              ]}
              title="List Of Reference Document"
            />
          </div>
        </div>
        <MessageLog
          errorMessages={[..._errorMessages]}
          successMessages={[]}
          warningMessages={[]}
          clearMessages={clearMessages}
        ></MessageLog>
      </div>
    </section>
  );
}

export default Index;
